import { defineComponent as _defineComponent } from 'vue'
import { ref, computed, onBeforeUnmount } from 'vue';
import DeviceSelect from './DeviceSelect.vue';
import { useRoomStore } from '../../stores/room';
import { SettingMode } from '../../constants/render';
import { useI18n } from '../../locales';
import { storeToRefs } from 'pinia';
import { useBasicStore } from '../../stores/basic';
import { isElectron } from '../../utils/environment';
import useGetRoomEngine from '../../hooks/useRoomEngine';
import TuiButton from '../common/base/Button.vue';

interface Props {
  mode?: SettingMode;
  audioVolume?: number;
  theme?: string;
}

export default /*#__PURE__*/_defineComponent({
  __name: 'AudioSettingTab',
  props: {
    mode: null,
    audioVolume: null,
    theme: null
  },
  setup(__props: any) {

const props = __props as {
  mode?: SettingMode;
  audioVolume?: number;
  theme?: string;
};


const settingMode = props.mode || SettingMode.SIMPLE;
const isSampleMode = computed(() => settingMode === SettingMode.SIMPLE);
const isDetailMode = computed(() => settingMode === SettingMode.DETAIL);

const basicStore = useBasicStore();
const { userId } = storeToRefs(basicStore);
const roomStore = useRoomStore();
const { speakerList, userVolumeObj, currentSpeakerId } = storeToRefs(roomStore);
const roomEngine = useGetRoomEngine();
const trtcCloud = roomEngine.instance?.getTRTCCloud();

const themeClass = computed(() =>
  props.theme ? `tui-theme-${props.theme}` : ''
);

const volumeTotalNum = computed(() => (isDetailMode.value ? 36 : 28));

const volumeNum = computed(() => {
  const volume = props.audioVolume || userVolumeObj.value[userId.value] || 0;
  return (volume * volumeTotalNum.value) / 100;
});

const showVolume = computed(
  () => isSampleMode.value || (isDetailMode.value && isTestingMicrophone.value)
);

const isTestingMicrophone = ref(false);

/**
 * Click on the microphone [Test] button
 **/
function handleMicrophoneTest() {
  isTestingMicrophone.value = !isTestingMicrophone.value;
}

const isTestingSpeaker = ref(false);
const audioPlayer = document?.createElement('audio');
if (audioPlayer && typeof audioPlayer.loop !== 'undefined') {
  audioPlayer.loop = true;
}
const { t } = useI18n();

/**
 * Click on the speaker [Test] button
 **/
async function handleSpeakerTest() {
  const SPEAKER_TEST_URL =
    'https://web.sdk.qcloud.com/trtc/electron/download/resources/media/TestSpeaker.mp3';
  isTestingSpeaker.value = !isTestingSpeaker.value;
  const isStartSpeakerTest = isTestingSpeaker.value;
  if (isElectron) {
    if (isStartSpeakerTest) {
      trtcCloud?.startSpeakerDeviceTest(SPEAKER_TEST_URL);
    } else {
      trtcCloud?.stopSpeakerDeviceTest();
    }
    return;
  }

  if (!audioPlayer) {
    return;
  }
  if (isStartSpeakerTest) {
    await audioPlayer?.setSinkId(currentSpeakerId.value);
    audioPlayer.src = SPEAKER_TEST_URL;
    audioPlayer.play();
  } else {
    audioPlayer.pause();
    audioPlayer.currentTime = 0;
  }
}

onBeforeUnmount(() => {
  if (isElectron) {
    trtcCloud?.stopSpeakerDeviceTest();
    return;
  }
  audioPlayer && audioPlayer.pause();
});

return { __sfc: true,props, settingMode, isSampleMode, isDetailMode, basicStore, userId, roomStore, speakerList, userVolumeObj, currentSpeakerId, roomEngine, trtcCloud, themeClass, volumeTotalNum, volumeNum, showVolume, isTestingMicrophone, handleMicrophoneTest, isTestingSpeaker, audioPlayer, t, handleSpeakerTest, DeviceSelect, SettingMode, TuiButton }
}

})